import React, { useState, Component } from 'react';
import axios from 'axios';
import metaData from "../metaData";
import loader from "../images/loader.gif"
import expand from "../images/expand.jpg"
import { ItemGroup } from 'rc-menu';
let getDwellings = metaData[0].getDwellings;
let metadata = metaData[0].metadata;
let dwellings;
let prevProps;
let show;
let addressString=""
let loading=false;
let imgLoader="";
let loadOn="";
let self;

function floorString(floorNum) {
  floorNum = parseInt(floorNum);
  if (floorNum <= 0) {
    if (floorNum === -3) {
      return "Second Level Ground Floor";
    }

    if (floorNum === -2) {
      return "Lower Level Ground Floor";
    }

    if (floorNum === -1) {
      return "Basement Level Ground Floor";
    }

    return "Ground Floor";
  }

  var s = ["th", "st", "nd", "rd"];
  var v = floorNum % 100;
  return floorNum + (s[(v - 20) % 10] || s[v] || s[0]) + " Floor";

}

export default class ZipprData extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dropDownClicked: false,
      clickedDwelling: "",
      dwellings: [],
      floorsData: [{ zippr: "APKD-PTN400174", badge: 1 }, { zippr: "APGD-PTN400174", badge: 2 }],
      clickedMetaData: false,
      update: false,
      zipprMetaData: [],
      clickedZipprMetadataButton: false,
      loading:false,
      imageExpanded:false,
      metaDataLoading:false,
      loadImage:false
    }
    this.getDwellingsApiCall = this.getDwellingsApiCall.bind(this);
    this.callReturn=this.callReturn.bind(this);
    self=this
  }



  componentDidMount() {
    this.getDwellingsApiCall();
    prevProps = this.props.zipprsData

  }

  componentDidUpdate(prevState) {
    // if(prevState.dwellings!==this.state.dwellings){
    // this.getDwellingsApiCall()
    // }
    // if(prevProps!==this.props.zipprsData){
    //     this.getDwellingsApiCall();
    //     return
    //   }
  }
  componentWillReceiveProps(nextProp) {
    if (nextProp.zipprsData !== this.props.zipprsData) {
      this.getDwellingsApiCall(nextProp.zipprsData.zippr);
      this.setState({
        clickedZipprMetadataButton: false,
        loadImage:true
      })
    }
  }

  dropDownClicked(e) {
    e.preventDefault();
    let clickedName = e.target.name;
    if (this.state.clickedDwelling == clickedName) {
      clickedName = ""
    } else if (this.state.clickedDwelling !== clickedName) {
      clickedName = e.target.name;
    }
    if (!this.state.clickedDwelling) {
      clickedName = e.target.name
    }

    this.setState({
      dropDownClicked: !this.state.dropDownClicked,
      clickedDwelling: clickedName

    })
  }

  getDwellingsApiCall(zippr) {

    if (zippr) {
      getDwellings.params.building_zippr = zippr
    } else {
      getDwellings.params.building_zippr = this.props.zipprsData.zippr;
    }


    axios.get(getDwellings.url, {
      params: getDwellings.params,
      headers: metaData[0].headers
    }).then(res => {
      if (res.data.response) {
        dwellings = res.data.response.dwellingZipprs.zipprs;
        console.log(res.data.response.dwellingZipprs,"res.data.response.dwellingZipprs")
        this.setState({
          dwellings: res.data.response.dwellingZipprs
        })
      } else {
        this.setState({
          dwellings: []
        })
      }
    }).then((resp) => {
    })

  }

  metaDataClick(e) {
    this.setState({
      metaDataLoading:true
    })
    let clickedName = e.target.name;
    if (this.state.clickedMetaData == clickedName) {
      clickedName = ""
    } else if (this.state.clickedMetaData !== clickedName) {
      clickedName = e.target.name;
    }
    if (!this.state.clickedMetaData) {
      clickedName = e.target.name
    }

    metadata.params.zippr = clickedName;
    axios.get(metadata.url, {
      params: metadata.params,
      headers: metaData[0].headers
    })
      .then(res => {
        if (res.data.response) {
          this.state.dwellings.map((dwelling) => {
            if (dwelling.floor == this.state.clickedDwelling) {
              dwelling.zipprs.map((individuvalDwelling) => {
                if (res.data.response.MetaDataObjs[0].zippr == individuvalDwelling.zippr) {
                  if (res.data.response.MetaDataObjs[0].metadata) {
                    let obj = res.data.response.MetaDataObjs[0].metadata;
                    let metaArray = []
                    Object.keys(obj).map(function (key, index) {
                      let object = {
                        type: key,
                        value: obj[key]
                      }
                      metaArray.push(object)
                    })
                    individuvalDwelling.metaData = metaArray
                    this.setState({
                      update: !this.state.update
                    })
                  }

                }
              })
            }
          })
        }else{
          this.setState({
            metaDataLoading:false
          })
        }
      })

    this.setState({
      clickedMetaData: clickedName
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.dwellings) {
      return true;
    }
    return false;
  }
  zipprMetaData(e) {
    this.setState({
      clickedZipprMetadataButton: !this.state.clickedZipprMetadataButton,
      loading:true,
      zipprMetaData:[]
    })
    if (this.props.zipprsData) {
      metadata.params.zippr = e.target.name;
      axios.get(metadata.url, {
        params: metadata.params,
        headers: metaData[0].headers
      })
        .then(res => {
          if (res.data.response) {
            let obj = res.data.response.MetaDataObjs[0].metadata
            let metaArray = []
            Object.keys(obj).map(function (key, index) {
              let object = {
                type: key,
                value: obj[key]
              }
              metaArray.push(object)
            })
            this.setState({
              zipprMetaData: metaArray,
            })
          }else{
            this.setState({
              loading: false,
            })
          }

        })
    }

  }

  imageExpand(){
    this.setState({
      imageExpanded:!this.state.imageExpanded
    })
  }
  callReturn(){
    loading=false;
    this.setState({
      loadImage:false
    })
  }

  render() {

    var divimg = document.getElementById("zippr-image-id");
    if(divimg){
      divimg.onload = function() {
       self.setState({
          loadImage:false
        })
    };
  }


if(this.props.zipprsData){
    let addressObj=this.props.zipprsData.address_v3;
     addressString=addressObj.user_aptnum + ", " + addressObj.user_buildingname +  ", "+ addressObj.landmark +  ", "+ addressObj.road_name +", "+ addressObj.sublocality +", "+ addressObj.locality + ", "+ addressObj.city + ", "+ addressObj.state + ", "+ addressObj.country +", "+  addressObj.postal_code ;
}

let redirect_url=`https://zip.pr/IN/${this.props.zipprsData.zippr?this.props.zipprsData.zippr:""}`;

    return (
      <div>

        <row className='image-row'>
          <div className='col-md-6 img-col1' id="img-col1">

            <a onClick={this.imageExpand.bind(this)} data-toggle="modal" data-target="#exampleModalCenter" ><img className='glyphicon glyphicon-fullscreen fullscreen-icon ' src={expand} /></a>
      {this.state.loadImage ?  <img className='zippr-loader' src='https://cdn.shopify.com/s/files/1/0222/7018/1472/t/7/assets/shopify_logo.gif?v=7646194843727540658'
                    // {loader}
                  />
                :
                <img className='zippr-image' id="zippr-image-id" src={this.props.zipprsData.zippr_media ? this.props.zipprsData.zippr_media.images[0].default.url : "https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_1200x1200.gif"} alt="photo" />

                 }


          </div>
          <div className='col-md-6 img-col2'>
            <div className='zippr-code'><a className='zippr-code' href={redirect_url} target='_blank'>{this.props.zipprsData.zippr}</a></div>
            <br />
              <p>{addressString}</p>
          </div>
        </row>
        <br />

        <row className='zippr-data-row'>
          <div className='col-md-6 zippr-data-col1'>
            <div className='zippr-data-titel'>
              <p><b>Property Type</b></p>
              <p><b>Building Type</b></p>
              {/* <p><b>PTIN</b></p>
              <p><b>TSN</b></p>
              <p><b>Trade License</b></p> */}
            </div>
          </div>
          <div className='col-md-6 zippr-data-col1'>
            <div className='zippr-data'>
              <p>{this.props.zipprsData.property_type ? this.props.zipprsData.property_type : "-"}</p>
              <p>{this.props.zipprsData.building_type ? this.props.zipprsData.building_type : "-"}</p>
              {/* <p>--</p>
              <p>--</p>
              <p>--</p> */}
            </div>
          </div>
        </row>
        <row>
          <button className='btn btn-info btn-lg btn-block btn-sm' name={this.props.zipprsData.zippr} onClick={this.zipprMetaData.bind(this)}>Building MetaData</button>
          {
            this.state.clickedZipprMetadataButton ?
              (this.state.zipprMetaData.length > 0 ? (this.state.zipprMetaData.map((meta) => {
                // return <li class="list-group-item d-flex justify-content-between align-items-center">
                //   {meta.type}
                //   <span >{meta.value}</span>
                // </li>
                return  <table class="table table-sm table-hover">
                <thead>
                 
                </thead>
                <tbody>
                  {meta.type=='property_id' ? 
                  <tr>
                  <td><a href={redirect_url ? redirect_url : ""} target='_blank'>{meta.type}</a></td>
                  <td className='metadata-right-data'><a href={redirect_url ? redirect_url : ""} target='_blank'>{meta.value}</a></td>
                  
                </tr>
                :
                <tr>
                    <td>{meta.type}</td>
                    <td className='metadata-right-data'>{meta.value}</td>
                    
                  </tr>
                }
                  
                  
                </tbody>
              </table>
              })) :
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  {/* <span >No Data Found</span> */}
                  {this.state.loading ?
                  <img className='loader' src=
                    {loader}
                  />
                  :"No Data"}
                </li>
              )
              : ""

          }
        </row>
        <br />
        {this.state.dwellings.length > 0 ?
          (this.state.dwellings.map((ele) => {
            return <div>
              <button type="button" name={ele.floor} class="btn btn-primary btn-lg btn-block btn-sm" onClick={this.dropDownClicked.bind(this)}>{
                // ele.floor == "0" ? "Ground Floor" : "Floor " + ele.floor
                floorString(ele.floor)
              }</button>
              {this.state.clickedDwelling == ele.floor ?
                <div>
                  {ele.zipprs.map((element) => {
                    return <ul class="list-group">
                      <li class="list-group-item d-flex justify-content-between align-items-center">
                        <a className='zippr-code' href={`https://zip.pr/IN/${element.zippr}`} target='_blank'><h6>{element.zippr} </h6></a>
                        {/* <h6>{element.zippr} </h6> */}
                        <span class="badge badge-secondary badge-pill">{element.badge ? element.badge : ""}</span>
                      </li>
                      <button type="button" name={element.zippr} class="btn btn-info btn-lg btn-block btn-sm meta-data-button" onClick={this.metaDataClick.bind(this)}>MetaData {this.state.clickedMetaData == element.name ? <button onClick={this.metaDataClick.bind(this)} name={element.name} className="glyphicon glyphicon-chevron-up metadata-indicator"></button> : <button onClick={this.metaDataClick.bind(this)} name={element.name} className="glyphicon glyphicon-chevron-down metadata-indicator"></button>} </button>

                      {
                        this.state.clickedMetaData == element.zippr ?
                          (element.metaData ? (element.metaData.map((meta) => {
                            return <li class="list-group-item d-flex justify-content-between align-items-center">
                              {meta.type}
                              <span >{" "+meta.value}</span>
                            </li>
                          })) :
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                              {/* <span >No Data Found</span> */}
                              {this.state.metaDataLoading ?
                              <img className='loader' src=
                                {loader}
                              />
                              :
                             <span>No Data</span>
                            }
                            </li>
                          )
                          : ""
                      }

                    </ul>
                  })}

                </div>
                :
                ""}
              <br />
            </div>

          })
          )
          : ""}



<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
  <h4 class="modal-title expand-modal-title" id="exampleModalLongTitle">{this.props.zipprsData ? this.props.zipprsData.zippr : "-"}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      <img className='zippr-image-inmodel' src={this.props.zipprsData.zippr_media ? this.props.zipprsData.zippr_media.images[0].default.url : ""} alt="photo" />
      </div>
      <div class="modal-footer">
        {/* <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> */}
      </div>
    </div>
  </div>
</div>


        <br />
        <br />
        <br />
      </div>
    )
  }
}




// dwellings[{
//   name: "Ground Floor",
//    zipprs: [
//      { name: "APKD-PTN400174",
//       badge: 1,
//        meta: [
//          { type: "electricityBill",
//           value: 150 }]
//         },
//          { name: "APGD-PTN400174",
//           badge: 2,
//            meta: [{ type: "electricityBill", value: 100 }]
//            }] },
//  { name: "First Floor", zipprs: [{ name: "APKD-PTN400174", badge: 1, meta: [{ type: "electricityBill", value: 200 }] }, { name: "APGD-PTN400174", badge: 2, meta: [{ type: "electricityBill", value: 550 }] }] },],
